import { withErrorBoundary } from '@alfa-bank/site-util-error-boundary';
import type { ComponentType, PropsWithChildren } from 'react';

import { hoist, createWrapper } from './helpers';
import type { ICreateWidgetWithErrorBoundary, TOptions } from './models';

/**
 * Функция hoc, для создания виджета завернутого в ErrorBoundary
 */
export const createWidgetWithErrorBoundary: ICreateWidgetWithErrorBoundary =
    <T, U extends T>(dependencies?: T, options?: TOptions) =>
    (
        Widget: ComponentType<PropsWithChildren<U>>,
        FallbackWidget?: ComponentType<PropsWithChildren>
    ) =>
        hoist(
            withErrorBoundary(
                createWrapper(Widget, dependencies, options),
                // WithErrorBoundary принимает дополнительно компонент для фолбека
                FallbackWidget
            ),
            Widget,
            // Чтобы сказать TreeBuilder, что компонент уже имеет ErrorBoundary
            { HAS_ERROR_BOUNDARY: true }
        );
